import { IconButton } from "@commonlibs";
import { alpha } from "@commonlibs";
import styled, { css } from "styled-components";
import { Row } from "@commonlibs";

export const DatePickerCalendarHeaderRoot = styled(Row)(
    ({ theme }) => css`
        padding: ${theme.spacing.all(0, 0, 0, 3)};
        min-height: 3.5rem;
    `,
);

export const DatePickerArrowIcon = styled(IconButton)(
    ({ theme }) => css`
        color: ${theme.palette.primary};
        font-size: 0.75rem;
        padding: 0.75rem;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        &:active {
            background-color: ${alpha(theme.palette.primary, 0.3)};
        }
    `,
);
